import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
//import { reactI18nextModule } from "react-i18next";
import { initReactI18next } from "react-i18next"

import translationFR from "./assets/translations/fr-FR/translations.json"
import translationEN from "./assets/translations/en-EN/translations.json"
import translationES from "./assets/translations/es-ES/translations.json"
import translationDE from "./assets/translations/de-DE/translations.json"
import translationIT from "./assets/translations/it-IT/translations.json"
import translationPTBR from "./assets/translations/pt-BR/translations.json"

import { FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES } from "./const/languages.const"
import {
	collectTranslationKeys,
	createMissingTranslationKeyLogger,
} from "./utils/log-missing-translation-key"

// the translations
const resources = {
	fr: { translation: translationFR },
	en: { translation: translationEN },
	es: { translation: translationES },
	de: { translation: translationDE },
	it: { translation: translationIT },
	"pt-BR": { translation: translationPTBR },
}

// French is the reference catalog: only its keys are reported as missing, so
// user data passed to `t()` never reaches the console (OC-140).
const logMissingTranslationKey = createMissingTranslationKeyLogger(
	collectTranslationKeys(translationFR),
)

// Exported so the tests exercise the real configuration.
export const I18N_OPTIONS = {
	resources,
	fallbackLng: FALLBACK_LANGUAGE,
	debug: false,
	supportedLngs: SUPPORTED_LANGUAGES,
	// Report keys absent from every loaded translation (OC-140). No backend
	// is configured, so `saveMissing` only triggers the handler — nothing is
	// written anywhere. "current" reports the user's language rather than
	// the fallback one.
	saveMissing: true,
	saveMissingTo: "current",
	missingKeyHandler: logMissingTranslationKey,
	react: {
		useSuspense: true,
	},
}

i18n.use(LanguageDetector)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init(I18N_OPTIONS)

export default i18n
